/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from './../lib/lib'
import 'jquery-ui'

export default class Dropdowns {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    let activeDefault = 0

    if (
      typeof jQuery(this).data('active-default') !== 'undefined' &&
      jQuery(this).data('active-default').toString() === 'false'
    ) {
      activeDefault = false
    }

    const active = lib.getDataAttr(this.$element, 'active', activeDefault)
    const className = this.$element.attr('class').split(' ')[0]

    this.$element.accordion({
      active: active,
      collapsible: true,
      heightStyle: 'content',
      header: `.${className}__head`,
    })
  }
}
